import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Route } from '../../types/Route';
import { Redirect } from 'react-router-dom';
import { useUser } from '../../hooks/useUser';
import { PageLoading } from '../../components/pageLoading/PageLoading';
import { UserType } from '../../types/UserType';

export const Home = () => {
  const { authenticated } = useAuth();
  const { user, fetching } = useUser();

  if (!authenticated) {
    return (
      <Redirect
        to={{ pathname: Route.Login, search: window.location.search }}
      />
    );
  }
  if (!user || fetching) {
    return <PageLoading />;
  }
  const isManager =
    user && [UserType.Manager, UserType.Director].includes(user.type);

  return <Redirect to={isManager ? Route.Consultants : Route.Roofers} />;
};
